module.exports = __webpack_public_path__ + "static/hallways-a3a0625999b4c32bdb463fd7affdebac.jpg";